import ExpandToggle from "@threespot/expand-toggle";

export default (function () {
    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    const toggles = document.querySelectorAll("[data-expands]");

    toggles.forEach(el => new ExpandToggle(el));
})();